var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showReportDashboard
    ? _c(
        "div",
        { staticClass: "reports-dashboard" },
        [
          _c("header", { staticClass: "reports-dashboard__header" }, [
            _c(
              "div",
              { staticClass: "reports-dashboard__nav-title" },
              [
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      content: _vm.$t.__("common.actions.back"),
                      placement: "bottom-start",
                      arrow: false
                    }
                  },
                  [
                    _c("CompassIconButton", {
                      attrs: { icon: "caret-left" },
                      on: { click: _vm.handleGoBackToListingReports }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "h1",
                  {
                    staticClass:
                      "typographies-heading-h1 reports-dashboard__title-h3"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.report.name) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showCategory
                  ? _c("CompassTag", { attrs: { color: _vm.getColorTag } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.getLabelCategory) +
                          "\n            "
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "typographies-paragraph-medium-regular reports-dashboard__subtitle"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.report.description) +
                    "\n        "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("luzmo-embed-dashboard", {
            ref: "dashboardInstance",
            attrs: {
              dashboardId: _vm.report.id,
              switchScreenModeOnResize: "",
              authKey: _vm.auth.key,
              authToken: _vm.auth.token
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }